import styled from 'styled-components';
import { _m, _mx, _my, _mt, _mr, _mb, _ml, _mbs, _mie, _mbe, _mis, _mbl, _mi } from './core';
export function m(values) {
  return function (_ref) {
    let {
      theme
    } = _ref;
    return _m(values, theme);
  };
}
export function mx(values) {
  return function (_ref2) {
    let {
      theme
    } = _ref2;
    return _mx(values, theme);
  };
}
export function my(values) {
  return function (_ref3) {
    let {
      theme
    } = _ref3;
    return _my(values, theme);
  };
}
export function mt(values) {
  return function (_ref4) {
    let {
      theme
    } = _ref4;
    return _mt(values, theme);
  };
}
export function mr(values) {
  return function (_ref5) {
    let {
      theme
    } = _ref5;
    return _mr(values, theme);
  };
}
export function mb(values) {
  return function (_ref6) {
    let {
      theme
    } = _ref6;
    return _mb(values, theme);
  };
}
export function ml(values) {
  return function (_ref7) {
    let {
      theme
    } = _ref7;
    return _ml(values, theme);
  };
}
export function mbs(values) {
  return function (_ref8) {
    let {
      theme
    } = _ref8;
    return _mbs(values, theme);
  };
}
export function mie(values) {
  return function (_ref9) {
    let {
      theme
    } = _ref9;
    return _mie(values, theme);
  };
}
export function mbe(values) {
  return function (_ref10) {
    let {
      theme
    } = _ref10;
    return _mbe(values, theme);
  };
}
export function mis(values) {
  return function (_ref11) {
    let {
      theme
    } = _ref11;
    return _mis(values, theme);
  };
}
// We already got a mixin `mb` which stands for margin-bottom. So we are using `mbl` which stands for logical margin-block.
export function mbl(values) {
  return function (_ref12) {
    let {
      theme
    } = _ref12;
    return _mbl(values, theme);
  };
}
export function mi(values) {
  return function (_ref13) {
    let {
      theme
    } = _ref13;
    return _mi(values, theme);
  };
}
export const Margin = styled.div.attrs({
  'data-mesh-component': 'MARGIN'
})`
  ${_ref14 => {
  let {
    inline
  } = _ref14;
  return inline && 'display: inline-block;';
}}
  ${_ref15 => {
  let {
    all,
    theme
  } = _ref15;
  return all && _m(all, theme);
}}
  ${_ref16 => {
  let {
    horizontal,
    theme
  } = _ref16;
  return horizontal && _mx(horizontal, theme);
}} 
  ${_ref17 => {
  let {
    vertical,
    theme
  } = _ref17;
  return vertical && _my(vertical, theme);
}} 
  ${_ref18 => {
  let {
    top,
    theme
  } = _ref18;
  return top && _mt(top, theme);
}} 
  ${_ref19 => {
  let {
    right,
    theme
  } = _ref19;
  return right && _mr(right, theme);
}} 
  ${_ref20 => {
  let {
    bottom,
    theme
  } = _ref20;
  return bottom && _mb(bottom, theme);
}} 
  ${_ref21 => {
  let {
    left,
    theme
  } = _ref21;
  return left && _ml(left, theme);
}}

  ${_ref22 => {
  let {
    blockStart,
    theme
  } = _ref22;
  return blockStart && _mbs(blockStart, theme);
}} 
  ${_ref23 => {
  let {
    inlineEnd,
    theme
  } = _ref23;
  return inlineEnd && _mie(inlineEnd, theme);
}} 
  ${_ref24 => {
  let {
    blockEnd,
    theme
  } = _ref24;
  return blockEnd && _mbe(blockEnd, theme);
}} 
  ${_ref25 => {
  let {
    inlineStart,
    theme
  } = _ref25;
  return inlineStart && _mis(inlineStart, theme);
}}

  ${_ref26 => {
  let {
    block,
    theme
  } = _ref26;
  return block && _mbl(block, theme);
}} 
  ${_ref27 => {
  let {
    inline,
    theme
  } = _ref27;
  return inline && _mi(inline, theme);
}}
`;
Margin.displayName = 'Margin';